import { types } from "../action-types";

const initialState = {
    loading: false,
    success: false,
    error: false,
};

const deleteEmpAlbumsReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.DELETE_EMP_ALBUMS_REQUESTED:
            return {
                ...state,
                loading: true,
            };

        case types.DELETE_EMP_ALBUMS_SUCCESS:
            return {
                ...state,
                loading: false,
                success:true,
                error: false,
            };
        case types.DELETE_EMP_ALBUMS_FAILURE:
            return {
                ...state,
                loading: false,
                success:action?.payload?.data?.errorMessage == `Missing required key 'Bucket' in params` ? true :false,
                error: true,
            };
            case 'RESET_DELETE_SUCCESS':
                return { ...state, success: false };
    
            default:
                return state;
        }
};
export default deleteEmpAlbumsReducer;
